export const MAX_CASE_ID_LENGTH = 25 // this includes prefix/suffix values
export const DCP_SESSION_ALIVE_EXPIRATION = 25 // in minutes
export const REFRESH_TTL = 0.15 // how long until refresh cookie expiration in minutes

export const MAX_SELECTED_FACTORS = 3
export const MAXIMUM_FACTORS_PER_OPTION=5
export const MAXIMUM_CHARACTERS_PER_FACTOR=80

export const FACTOR_EFFECTS = {
  sliderMax: 6,
  sliderMin: 0,
  uninitializedWeight: 0,
  text: ['Move The Slider', 'No Support', 'A Little Support', 'Some Support', 'Much Support', 'Very Much Support', 'Overwhelming Support'],
  weights: [0, 1.1, 1.3, 1.5, 1.7, 1.9, 9.9]
}

export const FACTOR_IMPORTANCE = {
  sliderMax: 6,
  sliderMin: 0,
  uninitializedWeight: 0,
  text: ['Move The Slider','The Same', 'A Little More', 'Somewhat More', 'Much More', 'Very Much More', 'Overwhelmingly More'],
  weights: [0, 1.1, 1.3, 1.5, 1.7, 1.9, 9.9]
}

export const DEMOGRAPHICS={
  races: ['White', 'Black, African American', 'Asian', 'American Indian or Alaskan Native', 'Native Hawaiian or Other Pacific Islander', 'Other'],
  maritalStatuses: ['Single', 'Married', 'Living As Married', 'Divorced', 'Separated', 'Widowed', 'Never Married'],
  educations: ['Completed less than High School', 'Completed High School or Equivalent Degree (GED)', 'Completed Non College/ Business/Trade/Technical School', '2-Year Associate\'s Degree', 'Completed College (BS or BA)', 'Graduate Degree', 'PhD or other Doctorate Degree']
}

export const CASE_ID_HELPER_TEXT = 'Case ID Not Unique'
export const ADMIN_EMAIL = 'Health.Decisions@jefferson.edu'
export const SESSION_COMPLETE = 'This Is A Read Only Session'
export const SESSION_COMPLETE_ADMIN = 'This Is A Completed Session'
export const EDUCATION_MATERIALS_NO_MATERIALS_WARNING = 'Educational materials are not yet available. Administrators have been notified.'
export const EDUCATION_MATERIALS_NO_MATERIALS_TEXT = 'Indicate Reviewed Educational Material'
export const EDUCATION_MATERIALS_NO_MATERIALS_CONFIRM_BUTTON_TEXT = 'End Session'
export const EDUCATION_MATERIALS_REVIEW_MATERIALS_WARNING = 'Please review the educational material before checking off.'
export const EDUCATION_MATERIALS_REVIEW_MATERIALS_CONFIRM_BUTTON_TEXT = 'Ok, Let\'s Try Again'

export const SLIDER_MOON_IMAGES = [
  '/svg/phases/moon__1.svg',
  '/svg/phases/moon__2.svg',
  '/svg/phases/moon__3.svg',
  '/svg/phases/moon__4.svg',
  '/svg/phases/moon__5.svg',
  '/svg/phases/moon__6.svg'
]

export const REPORT_MOON_IMAGES = [
  "/svg/chart/moon_graphics_report_1.svg",
  "/svg/chart/moon_graphics_report_2.svg",
  "/svg/chart/moon_graphics_report_3.svg",
  "/svg/chart/moon_graphics_report_4.svg",
  "/svg/chart/moon_graphics_report_5.svg",
  "/svg/chart/moon_graphics_report_6.svg",
  "/svg/chart/moon_graphics_report_7.svg",
  "/svg/chart/moon_graphics_report_8.svg",
  "/svg/chart/moon_graphics_report_9.svg",
  "/svg/chart/moon_graphics_report_10.svg"
]

export const REPORT_SCORE_RANGES = [0.045, 0.1445, 0.2445, 0.3445, 0.4445, 0.5445, 0.6445, 0.7445, 0.8445, 1]


// WEBPACK FOOTER //
// ./src/constants.js